import { useConfigurationContext } from '@app/root/ConfigurationContext';
import { MissionVisibility } from '@wwf/sdk';
import { findMissionVisibilityLabel } from './chips/findMissionVisibilityLabel';

export const MissionVisibilityIcon = ({
    visibility,
}: {
    visibility: MissionVisibility;
}) => {
    const { missionVisibilityLabels } = useConfigurationContext();

    const label = findMissionVisibilityLabel(
        missionVisibilityLabels,
        visibility
    );

    if (!label?.icon) return null;

    const Icon = label.icon;
    return <Icon />;
};
